module.exports = __webpack_public_path__ + "img/paynow.d8ee5bb6.png";